import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Input from '../../../components/form/InputComLabel';
import { getIPAddress } from '../../../components/utils/GetIPAddress';
import useFetch from '../../../components/hooks/useFetch';

const EsqueciMinhaSenhaPFSemCPF = () => {
  const { t } = useTranslation();
  const methods = useForm();
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };
  const navigate = useNavigate();
  const [ipAddress, setIpAddress] = useState('');
  const location = useLocation();
  const dadosUsuario = location.state;
  const [modalAbertoToken, setModalAbertoToken] = useState(false);
  const { request } = useFetch();

  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);
  const openModalToken = () => {
    setModalAbertoToken(true);
  };
  const mascararEmail = (email) => {
    if (email) {
      const [usuario, dominio] = email.split('@');
      const usuarioMascarado = usuario.slice(0, 3) + 'xxx';
      return `${usuarioMascarado}@${dominio}`;
    } else {
      return '';
    }
  };
  const handleSubmit = async (data) => {
    var meioEnvioEnviar = methods.getValues('meioEnvio');
    if (!meioEnvioEnviar) {
      meioEnvioEnviar = 'E';
    }
    const celular = dadosUsuario.dddMovel + dadosUsuario.foneMovel;
    const dados = [
      dadosUsuario.idCorreios,
      ipAddress,
      meioEnvioEnviar,
      dadosUsuario.email,
      celular,
    ];
    navigate('/redefinirSenha', { state: dados });
  };
  return (
    <>
      <form id="formEsqueciSenha" onSubmit={methods.handleSubmit(handleSubmit)}>
        <div id="recuperar-senha" className="card bg-superficie elev5">
          <img
            alt={t('cadastro.accessibility.carol_image')}
            id="img-carol-boasvindas"
            src="/images/carol-perfil.png"
          />
          <h2>{t('cadastro.titles.forgot_password')}</h2>
          <br />
          {dadosUsuario?.usuarioExternoPF?.ddiMovel === '55' ? (
            <div className="radio-container">
              <div className="titulo-radio subtitulo-p">
                <br />
                {t('cadastro.messages.info.token_delivery_method')}
              </div>
              <label className="radio">
                <Input
                  type="radio"
                  id="E"
                  name="meioEnvio"
                  value="E"
                  defaultChecked
                  {...formMethods}
                />
                <div className="subtitulo-p">
                  {t('cadastro.forms.options.email_option')} ({mascararEmail(dadosUsuario?.email)}){' '}
                </div>
              </label>

              <label className="radio">
                <Input
                  type="radio"
                  id="C"
                  name="meioEnvio"
                  //disabled="true"
                  value="C"
                  //disabled={dadosUsuario?.ddiMovel !== '55'}
                  {...formMethods}
                />
                <div className="subtitulo-p">
                  {t('cadastro.forms.options.mobile_option')} ({dadosUsuario?.dddMovel}){' '}
                  {dadosUsuario?.foneMovel.substring(0, 2)}xxx-xx
                  {dadosUsuario?.foneMovel.substring(7)}
                </div>
              </label>
            </div>
          ) : (
            <>
              <label>
                {t('cadastro.messages.info.token_email_only')}
                ({mascararEmail(dadosUsuario?.email)}) .
              </label>
            </>
          )}
          <div className="btns-row">
            <button
              id="btn-voltar"
              type="button"
              className="btn-txt"
              onClick={() => navigate('/login')}
            >
              {t('cadastro.forms.buttons.cancel')}
            </button>
            <button id="btn-prosseguir" className="btn-pre" type="submit">
              {t('cadastro.forms.buttons.change_password')}
            </button>
          </div>
          <hr />
          <h6 className="ainda-problema">{t('cadastro.messages.errors.still_problems')}</h6>
          <p className="legenda">
            {t('cadastro.messages.info.contact_help')}{' '}
            <a
              href="https://faleconosco.correios.com.br/cadastro/reclamacao-mc"
              className="txt-link"
            >
              {t('cadastro.legal.contact_us')}
            </a>
            . {t('cadastro.messages.info.update_email')}
          </p>
        </div>
      </form>
    </>
  );
};
export default EsqueciMinhaSenhaPFSemCPF;
